import { paintColors, woodColors } from "./colors.js";

export const modelSettings = {
    bathroom: {
        // cameraPos: [0, 2, -3],
        cameraPos: [0, 0, 0.5],
        availableMeshes: [
            "Floor_Grout",
            "polySurface25_4_4",
            "polySurface25_4_3",
            "polySurface25_4_2",
            "Shower_Grout_Wall_1",
            "Shower_Grout_Wall_1_2",
            "Wall_1_1",
            "Wall_1_2",
            "Wall_1_3",
            "polySurface25_4_1",
            "Drain",
        ],
        group1: [
            "polySurface25_4_4",
            "polySurface25_4_3",
            "polySurface25_4_2",
            "Shower_Grout_Wall_1",
            "Shower_Grout_Wall_1_2",
        ],
        group2: ["Wall_1_1", "Wall_1_2", "Wall_1_3", "polySurface25_4_1"],
        group3: ["Drain"],
        lights: {
            directionalLights: [
                { pos: [0, 4, 2.5], intensity: 0.4, shadow: true },
                { pos: [3, -3, 2.5], intensity: 0.3 },
                { pos: [-4, -3, 2.5], intensity: 0.3 },
                { pos: [-1.7, 2, -2.5], intensity: 0.4 },
            ],
            shadowLights: [[0, 1.2, 0.015]],
            mainLights: [
                { pos: [-0.915, 1.2, -0.67], power: 1 },
                { pos: [-0.915, 1.2, 0.61], power: 1 },
                { pos: [-0.915, 1.2, 1.8], power: 1 },
                { pos: [0.92, 1.2, -0.58], power: 1 },
                { pos: [0.92, 1.2, 0.61], power: 1 },
                { pos: [0.92, 1.2, 1.8], power: 1 },
                { pos: [-0.915, 1.2, -1.77], power: 1 },
            ],
            wallLights: [
                [-1.52, 0.087, 2.015],
                [-1.52, 0.087, 0.94],
                [-1.52, 0.087, -0.135],
            ],
        },
        envPos: [0, -13, -5],
        cameraBox: [1.4, -1.4, 1, -1.2, 2, -1],
        typeMeshes: {
            metal: [
                "Mesh011",
                "Mesh013",
                "Mesh022",
                "Mesh023",
                "Mesh025_1",
                "Mesh028_1",
                "Mesh034_1",
                "SinkFaucet",
                "Towe_lRack",
                "DoorHandle",
                "VanityHandles",
                "Shower_Floor",
            ],
            wall: [
                "Floor_Grout",
                "polySurface25_4_4",
                "polySurface25_4_3",
                "polySurface25_4_2",
                "Shower_Grout_Wall_1",
                "Shower_Grout_Wall_1_2",
                "Wall_1_1",
                "Wall_1_2",
                "Wall_1_3",
                "Wall_2",
                "polySurface25_4_1",
            ],
            wood: ["Trimming", "Mesh014", "Mesh014_1", "Mesh036", "Mesh036_1", "Mesh036_2"],
            wood2: ["Door_Panel", "VanityCabinet"],
            textile: [],
            textile2: [],
            textile3: [],
            textile4: [],
            glass: ["Mesh025"],
            window: ["Mesh037", "Mesh038"],
            mirror: ["Mirror_Glass", "Mirror_Glass_1"],
            plastic: [
                "Mesh037_1",
                "Mesh038_1",
                "Mesh039",
                "Mesh039_2",
                "Mesh040",
                "Mesh040_1",
                "Mesh040_2",
            ],
            plastic2: [],
            stone: ["VanityCounter"],
            ceramic: ["Sink"],
            emissive: [],
            notReceiveShadow: ["Mesh028", "Mesh011_2", "Mesh011_3"],
        },
    },

    bedroom: {
        cameraPos: [0, 0, 2.5],
        availableMeshes: ["Wall_1", "Wall_2", "Wall_3", "Wall_4", "Floor_1"],
        group1: ["Wall_1", "Wall_2", "Wall_3", "Wall_4"],
        group2: [],
        group3: [],
        lights: {
            directionalLights: [
                { pos: [0, 4, 2.5], intensity: 0.3 },
                { pos: [0, 4, -0.5], intensity: 0.3 },
                { pos: [3, -3, 2.5], intensity: 0.3 },
                { pos: [-4, -3, 2.5], intensity: 0.3 },
            ],
            shadowLights: [[0.015, 0.85, 2.535]],
            mainLights: [
                { pos: [-1.97, 1.35, 3.76], power: 1.7 },
                { pos: [-1.97, 1.35, 1.31], power: 1.7 },
                { pos: [2, 1.35, 3.76], power: 1.7 },
                { pos: [2, 1.35, 1.31], power: 1.7 },
            ],
            wallLights: [],
        },
        envPos: [0, -14, 0],
        cameraBox: [2.4, -2.3, 1.2, -1.3, 4.3, 0.9],
        typeMeshes: {
            metal: [
                "Cabinet_DresserHandles_All",
                "DoorHandle_Mesh",

                "Closet_Handle",
                "Mirror_Frame",
                "Cabinet_DresserBase_01",
                "Cabinet_nightstand_Legs_01",
                "Cabinet_nightstand_Handle_02",
                "Cabinet_nightstand_Handle_08",
                "Cabinet_nightstand_Legs_02",
                "Spotlight_01",
                "Spotlight_02",
                "Spotlight_03",
                "Spotlight_04",
            ],
            wall: ["Wall_1", "Wall_2", "Wall_3", "Wall_4", "Floor_1"],
            wood: ["Skirting_Mesh_1", "Door_Frame", "Legs_01", "Headpart_ToWall_01"],
            wood2: [
                "Door_PanelMiddle",
                "Door_Panel1",
                "Cabinet_Dresser_shelves",
                "Cabinet_nightstand_01",
                "Cabinet_nightstand_02",
                "Cabinet_Frame1",
                "Cabinet_DoorPanel_1",
                "Cabinet_door1",
                "Cabinet_Dresser",
            ],
            glass: ["Mesh025"],
            window: ["Window_glass2", "Window_glass1"],
            mirror: ["Mirror_Glass"],
            plastic: [
                "Switch_01",
                "Socket_02",
                "Celing_light_01",
                "Celing_light_02",
                "Celing_light_03",
                "Celing_Lamp",
                "Picture_Image_1",
            ],
            plastic2: [
                "Picture_Frame_1",
                "Curtains_holder_01",
                "Curtains_holder_02",
                "Curtains_holder_03",
                "Curtains_holder_04",
            ],
            emissive: [
                "Celing_light_Emisive_mesh_01",
                "Celing_Light_Emisive_mesh_02",
                "Celing_Light_Emisive_mesh_03",
            ],
            stone: ["VanityCounter"],
            ceramic: ["Sink"],
            textile: ["Mesh004_1", "Mattress_01", "Mesh004"],
            textile2: ["Linen_01"],
            textile3: ["Headpart_Soft_01", "Legs_Top"],
            textile4: ["Curtain_01", "Curtain_02", "Curtain_03", "Curtain_04"],
            notReceiveShadow: [],
        },
    },
};

export const colors = paintColors;
export const floorColors = woodColors;

export const range = {
    seamSize: {
        min: 0,
        max: 10,
    },
    tileWidth: {
        min: 10,
        max: 100,
    },
    tileHeight: {
        min: 10,
        max: 100,
    },

    carpetWidth: {
        min: 100,
        max: 340,
    },
    carpetHeight: {
        min: 100,
        max: 490,
    },
    rollWidth: {
        min: 50,
        max: 100,
    },
};

export const initialSettings = {
    seamSize: 1.5,
    tileWidth: 30,
    tileHeight: 30,
    material: "polish",
    carpetWidth: 340,
    carpetHeight: 490,
    seamColor: colors[0],
    texture: null,
    normalMap: null,
    isTile: true,
    pos: "horizontal",
    turned: false,
    options: "tile",
    carpet: null,
    inches: 6,
    length: 2,
    floorRotate: 0,
    floorColor: floorColors[0],
    isPlastic: false,
    rollWidth: 60,
};

export const lightTemperatures = ["rgb(255, 250, 225)", "rgb(255, 255, 255)", "rgb(230, 240, 252)"];
